import React from "react";
import {
    Modal,
    Box,
    TextField,
    Button,
    Container,
    Typography,
    createTheme,
    ThemeProvider,
} from "@mui/material";
import MessageModal from "./MessageModal";
import { URL, origin } from "../config";

export default function ChangeEmail(props) {
    const regex = new RegExp(/([a-zA-Z])+(@)([a-zA-Z]+)(\.)([a-zA-Z]+)/, "gm"); //regex to validate an email format

    const [error, setError] = React.useState("");
    const [input, setInput] = React.useState("");
    const [alert, setAlert] = React.useState(false);

    const theme = createTheme({
        secondary: "#EEEEEE",
        typography: {
            fontFamily: ["Tilt Warp", "sans-serif"].join(","),
        },
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            email: input,
        };
        fetch(`${URL}/update/email`, {
            method: "POST",
            mode: "cors",
            credentials: "include",
            headers: {
                "content-type": "application/json",
                Origin: `${origin}`,
            },
            body: JSON.stringify(data),
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.error) {
                    setError(data.error.message);
                    throw new Error(data.error.message);
                }
            })
            .then((response) => {
                setAlert(true);
                setError("");
                console.log(response);
            })
            .catch((err) => console.log(err));
    };

    const closeAlert = () => {
        setAlert(false);
    };

    const style = {
        backgroundColor: "whitesmoke",
        top: "50%",
        left: "50%",
        position: "absolute",
        transform: "translate(-50%, -50%)",
        width: "60%",
        boxShadow: 24,
        borderRadius: 2,
        minHeight: "30%",
        "@media (max-width: 75em)": {
            display: "flex",
            flexDirection: "column",
            width: "80%",
            maxHeight: "90vh",
            overflow: "auto",
        },
    };

    return (
        <>
            <ThemeProvider theme={theme}>
                <Modal open={props.open} onClose={props.onClose}>
                    <Container sx={{ display: "flex" }}>
                        <Box sx={style} display="flex" flexDirection="row">
                            <Box
                                sx={{
                                    backgroundColor: "#EEEEEE",
                                    borderRadius: "8px 0 0 8px",
                                    "@media (max-width: 75em)": {
                                        borderRadius: "0",
                                    },
                                }}
                                minWidth="60%"
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                            >
                                <Typography variant="h6" textAlign="center">
                                    Update email
                                </Typography>
                                <Box color="#5d5c5b" sx={{ m: 1, p: 3 }}>
                                    <Typography fontWeight="bold">
                                        Updating your email
                                    </Typography>
                                    <Typography>
                                        - Should be a valid email that you have
                                        access to
                                    </Typography>
                                    <Typography>
                                        - Used only for password recovery/reset
                                    </Typography>
                                </Box>
                            </Box>
                            <Box
                                display="flex"
                                flexDirection="column"
                                minWidth="40%"
                                alignItems="center"
                                justifyContent="center"
                            >
                                <TextField
                                    helperText={error}
                                    error={error ? true : false}
                                    value={input}
                                    onChange={(e) => setInput(e.target.value)}
                                    size="small"
                                    label="email"
                                    sx={{ width: "90%", my: 1 }}
                                />
                                <Button
                                    disabled={!regex.test(input)}
                                    variant="outlined"
                                    sx={{ m: 1, width: "50%" }}
                                    onClick={handleSubmit}
                                >
                                    Update
                                </Button>
                            </Box>
                        </Box>
                    </Container>
                </Modal>
                <MessageModal
                    severity="success"
                    title="successs"
                    open={alert}
                    onClose={closeAlert}
                >
                    updated email
                </MessageModal>
            </ThemeProvider>
        </>
    );
}
